import React, { Component } from 'react';

export class Elixir extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div 	className={ "ElixirBox elixir" }>
				<p className="elixirText"> { this.props.cost }</p>
      </div>
    )
  }
}

export default Elixir;



// WEBPACK FOOTER //
// ./src/Components/Elixir.js